/* eslint-disable no-use-before-define */
import { SuperOmega } from "@didi/superomega";
import { APP_KEY } from './const';
import { OMEGEATTR } from "@/utils"
import * as Sentry from "@sentry/react";
// omega实例：开发环境下使用SuperOmega，生产环境下使用父组件传进来的props.SuperOmega
let instance = SuperOmega;
let isProduction = process.env.NODE_ENV === 'production';

// 父组件的appKey
let _ParentAppKey = '';

const Omega = {
    trackEvent(eventId, attrs = {}) {
        // 非微前端壳页面打开情况下，omega的处理
        if (window.location.pathname === '/cs-ticket-system/'){
            window.trackEvent(eventId, attrs)
            return 
        }
        try {
            // 生产模式：配置父组件Omega实例的appKey为子组件appKey
            if (isProduction) {
                _ParentAppKey = instance.Omega.context.appKey;
                setAppKey(APP_KEY)
            }

            // 添加sentry监控
            let {canonical_country_code,userid,organization_id,utc_offset} = OMEGEATTR
            // 公共参数缺失
            if(!canonical_country_code || !userid || !organization_id || !utc_offset){
                Sentry.captureException('missing common auguments', {
                    extra: {
                        data: JSON.stringify(OMEGEATTR),
                        cookie: document.cookie
                    },
                })
            }

            // 触发埋点
            instance.trackClickEvent(
                eventId,
                Object.assign({}, attrs, OMEGEATTR)
            )
            // 生产模式：恢复父组件Omega实例的appKey
            if (isProduction) {
                setAppKey(_ParentAppKey)
            } 
        } catch (error) {
            console.error('error')
        }
    }
}

const setOmega = (omg) => {
    instance = omg;
}

const initOmega = () => {
    SuperOmega.initOmega({
        pt: "cs-ticket-system",
        country: "en",
        appKey: APP_KEY,
    });

    var attrs = OMEGEATTR
    SuperOmega.setOmgAttrs(attrs)
    window.Omega = window.omega = SuperOmega
    window.trackEvent = (eventId, attr) => {
        if (SuperOmega) {
            SuperOmega.trackClickEvent(eventId, Object.assign({}, attrs, attr))
        }
    }
}

// 仅用于生产环境
const setAppKey = (key) => {
    instance.Omega.context.appKey = key;
}

export { setOmega, initOmega };
export default Omega;
